export const ASSIGNMENT_TRANSITIONS = [
  'assigned_to_franchisee',
  'assigned_to_field_executive',
  'assigned_to_customer',
] as const;

export type AssignmentTransitionCode = (typeof ASSIGNMENT_TRANSITIONS)[number];

export type AssigneeKind = 'partner' | 'field_agent' | 'customer';

export interface AssigneeInput {
  kind: AssigneeKind;
  display: string;
  id?: string | null;
  freeText?: string;
}

const UUID_V4_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isAssignmentTransition(code: string): code is AssignmentTransitionCode {
  return (ASSIGNMENT_TRANSITIONS as readonly string[]).includes(code);
}

export function isValidUuid(value: string): boolean {
  return UUID_V4_RE.test(value);
}

function sanitizeDisplay(display: string): string {
  return display.replace(/[:\]]/g, '');
}

export function encodeAssigneeIntoNotes(input: AssigneeInput): string {
  const safeDisplay = sanitizeDisplay(input.display);
  const idSegment = input.id ? `:${input.id}` : '';
  const prefix = `[assignee:${input.kind}:${safeDisplay}${idSegment}]`;
  const trimmed = input.freeText?.trim() ?? '';
  return trimmed.length > 0 ? `${prefix} ${trimmed}` : prefix;
}
